import React from "react";
import { Modal, Button } from "react-bootstrap";
import ShareCard from "./ShareCard";

function ShareModal({
  show,
  onHide,
  total,
  totalPlus,
  throwScoringModeId,
  calculateShareStats,
  onDownload,
  playerName,
  eventName,
}) {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Share Your Round</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ShareCard
          total={total}
          totalPlus={totalPlus}
          throwScoringModeId={throwScoringModeId}
          calculateShareStats={calculateShareStats}
          playerName={playerName}
          eventName={eventName}
        />

        {/* Share Options */}
        <div
          style={{
            display: "flex",
            gap: "10px",
            flexWrap: "wrap",
            justifyContent: "center",
          }}
        >
          <Button
            variant="outline-primary"
            onClick={onDownload}
            style={{ minWidth: "200px", padding: "10px 20px" }}
          >
            📥 Download Image
          </Button>
        </div>

        <div className="text-center mt-3">
          <small className="text-muted">
            💡 Download your scorecard image and share on social media!
          </small>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default ShareModal;
